import React, { Component } from 'react';

class StampSvg extends Component
{
    render = () =>
    {
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
                 width={ this.props.width } height={ this.props.height }
                 viewBox="0 0 1941 766">
                <path id="Selection"
                      fill={ this.props.color }
                      d="M 918.00,37.00
           C 918.00,37.00 918.00,271.00 918.00,271.00
             918.00,274.03 917.85,277.14 919.01,280.00
             924.08,292.53 937.62,294.01 949.00,290.37
             949.00,290.37 957.00,287.00 957.00,287.00
             957.00,287.00 957.00,319.00 957.00,319.00
             957.00,321.18 957.22,324.74 955.98,326.57
             954.17,329.24 948.97,329.76 946.00,330.25
             935.60,331.95 925.88,330.94 916.00,327.30
             893.07,318.88 880.04,295.60 880.00,272.00
             880.00,272.00 880.00,37.00 880.00,37.00
             880.00,37.00 918.00,37.00 918.00,37.00 Z
           M 1882.00,37.00
           C 1882.00,37.00 1882.00,290.00 1882.00,290.00
             1882.00,290.00 1901.00,290.00 1901.00,290.00
             1901.00,290.00 1901.00,328.00 1901.00,328.00
             1901.00,328.00 1845.00,328.00 1845.00,328.00
             1822.62,328.00 1807.81,330.55 1791.17,312.00
             1770.78,289.26 1766.26,257.18 1764.18,228.00
             1763.92,224.37 1764.68,222.45 1764.91,219.00
             1765.77,206.45 1766.73,194.07 1770.67,182.00
             1775.94,165.84 1784.30,149.06 1799.00,139.55
             1813.72,130.01 1828.40,132.00 1845.00,132.00
             1845.00,132.00 1845.00,75.00 1845.00,75.00
             1845.00,75.00 1826.00,75.00 1826.00,75.00
             1826.00,75.00 1826.00,37.00 1826.00,37.00
             1826.00,37.00 1882.00,37.00 1882.00,37.00 Z
           M 190.00,46.21
           C 203.40,46.06 220.06,50.80 232.00,56.75
             245.20,63.34 256.85,70.93 266.83,82.00
             303.78,122.99 307.55,184.83 273.76,229.00
             261.66,244.82 248.66,254.56 231.00,263.24
             216.53,270.35 197.09,274.18 181.00,274.00
             169.84,273.87 153.40,270.85 143.00,266.80
             127.43,260.73 112.82,252.02 101.09,239.96
             64.67,202.55 58.11,143.12 86.05,99.00
             93.49,87.25 102.82,76.80 114.00,68.48
             131.83,55.21 147.31,49.70 169.00,46.21
             169.00,46.21 190.00,46.21 190.00,46.21 Z
           M 1006.00,141.00
           C 1006.00,138.79 1005.78,135.29 1007.02,133.42
             1008.70,130.89 1013.19,130.12 1016.00,129.62
             1024.53,128.08 1035.72,129.24 1044.00,131.72
             1067.93,138.90 1082.96,159.13 1083.00,184.00
             1083.00,184.00 1083.00,275.00 1083.00,275.00
             1082.47,319.91 1028.91,347.28 993.00,319.47
             983.21,311.90 977.06,300.61 973.34,289.00
             964.22,260.52 969.34,221.06 994.00,201.67
             998.30,198.29 1002.77,195.46 1008.00,193.75
             1014.05,191.76 1019.67,191.01 1026.00,191.00
             1026.00,191.00 1045.00,191.00 1045.00,191.00
             1045.00,187.39 1045.22,183.48 1044.21,180.00
             1043.62,177.94 1042.61,175.76 1041.35,174.02
             1035.54,165.94 1024.87,164.76 1016.00,167.97
             1016.00,167.97 1006.00,173.00 1006.00,173.00
             1006.00,173.00 1006.00,141.00 1006.00,141.00 Z
           M 1520.00,141.00
           C 1520.00,138.79 1519.78,135.29 1521.02,133.42
             1522.70,130.89 1527.19,130.12 1530.00,129.62
             1538.86,128.02 1550.45,129.31 1559.00,132.03
             1582.85,139.61 1596.96,160.32 1597.00,185.00
             1597.00,185.00 1597.00,274.00 1597.00,274.00
             1596.47,318.83 1543.25,348.00 1507.00,319.48
             1466.72,287.79 1476.77,191.10 1539.00,191.00
             1539.00,191.00 1559.00,191.00 1559.00,191.00
             1559.00,186.68 1559.14,183.21 1557.78,179.00
             1553.71,166.46 1540.15,164.04 1529.00,168.13
             1526.05,169.21 1522.81,171.43 1520.00,173.00
             1520.00,173.00 1520.00,141.00 1520.00,141.00 Z
           M 1289.00,328.52
           C 1263.68,335.00 1236.33,330.38 1219.52,309.00
             1215.59,304.01 1213.13,298.98 1211.08,293.00
             1206.38,279.30 1208.00,247.76 1208.00,232.00
             1208.00,232.00 1208.00,202.00 1208.00,202.00
             1208.00,176.21 1209.68,156.52 1233.00,140.04
             1237.60,136.79 1242.66,134.15 1248.00,132.36
             1256.76,129.41 1261.98,129.90 1271.00,130.00
             1290.41,130.23 1305.87,143.25 1314.46,160.00
             1325.37,182.27 1325.18,213.50 1314.46,236.00
             1306.15,254.28 1288.76,268.75 1268.00,269.00
             1268.00,269.00 1246.00,269.00 1246.00,269.00
             1246.00,269.00 1246.00,273.00 1246.00,273.00
             1246.02,275.89 1245.94,278.24 1246.99,281.00
             1254.93,301.77 1281.22,291.31 1296.00,286.33
             1296.00,286.33 1306.00,283.00 1306.00,283.00
             1306.00,283.00 1310.00,321.00 1310.00,321.00
             1303.33,323.67 1295.94,326.75 1289.00,328.52 Z
           M 1391.09,288.67
           C 1408.26,304.03 1427.09,282.59 1421.15,265.00
             1417.88,255.33 1406.23,250.22 1398.00,245.58
             1398.00,245.58 1382.00,237.74 1382.00,237.74
             1363.55,228.29 1346.27,215.64 1346.00,193.00
             1345.79,175.17 1349.49,159.41 1362.29,146.17
             1384.57,123.11 1426.14,124.39 1446.68,149.00
             1459.15,163.95 1459.00,177.85 1459.00,196.00
             1459.00,196.00 1422.00,196.00 1422.00,196.00
             1422.00,187.06 1423.48,177.04 1415.82,170.56
             1404.54,161.02 1384.79,167.78 1384.04,185.00
             1383.37,200.27 1397.07,206.79 1409.00,212.75
             1429.45,222.99 1458.68,235.07 1459.00,262.00
             1459.22,280.97 1456.98,298.10 1443.82,313.00
             1419.16,340.92 1374.79,334.12 1355.10,304.00
             1345.17,288.81 1347.00,276.07 1347.00,259.00
             1347.00,259.00 1384.00,259.00 1384.00,259.00
             1384.00,269.88 1382.04,280.58 1391.09,288.67 Z
           M 1629.00,184.00
           C 1629.01,176.26 1630.07,171.20 1633.01,164.00
             1639.91,147.12 1655.94,133.72 1674.00,130.23
             1677.66,129.80 1685.02,129.96 1689.00,130.23
             1694.77,130.07 1701.69,131.60 1707.00,133.88
             1719.53,139.26 1729.84,149.85 1735.74,162.00
             1739.23,169.19 1740.96,177.02 1741.00,185.00
             1741.00,185.00 1741.00,328.00 1741.00,328.00
             1741.00,328.00 1704.00,328.00 1704.00,328.00
             1704.00,328.00 1704.00,192.00 1704.00,192.00
             1703.99,186.04 1703.63,180.13 1700.15,175.01
             1691.87,162.86 1677.59,164.57 1669.65,176.00
             1666.43,180.64 1666.03,185.56 1666.00,191.00
             1666.00,191.00 1666.00,328.00 1666.00,328.00
             1666.00,328.00 1629.00,328.00 1629.00,328.00
             1629.00,328.00 1629.00,184.00 1629.00,184.00 Z
           M 796.00,132.00
           C 813.49,132.08 824.56,141.12 834.28,155.00
             847.00,173.17 852.34,195.19 854.08,217.00
             854.08,217.00 855.00,227.00 855.00,227.00
             855.38,259.43 845.42,310.11 812.00,324.12
             802.07,328.29 785.10,327.00 774.00,327.00
             774.00,327.00 774.00,356.00 774.00,356.00
             774.00,356.00 793.00,356.00 793.00,356.00
             793.00,356.00 793.00,394.00 793.00,394.00
             793.00,394.00 717.00,394.00 717.00,394.00
             717.00,394.00 717.00,356.00 717.00,356.00
             717.00,356.00 736.00,356.00 736.00,356.00
             736.00,356.00 736.00,169.00 736.00,169.00
             736.00,169.00 718.00,169.00 718.00,169.00
             718.00,169.00 718.00,132.00 718.00,132.00
             718.00,132.00 796.00,132.00 796.00,132.00 Z
           M 1146.00,323.19
           C 1134.93,317.64 1126.26,305.85 1120.76,295.00
             1109.98,273.75 1105.96,248.66 1106.00,225.00
             1106.01,218.33 1106.95,211.60 1107.87,205.00
             1112.42,172.27 1126.48,132.06 1166.00,132.00
             1166.00,132.00 1185.00,132.00 1185.00,132.00
             1185.00,132.00 1185.00,170.00 1185.00,170.00
             1185.00,170.00 1172.00,170.00 1172.00,170.00
             1168.49,170.01 1165.25,169.81 1162.00,171.45
             1156.95,174.01 1154.19,179.14 1151.76,184.00
             1146.62,194.27 1144.02,207.54 1144.00,219.00
             1143.97,238.12 1143.20,253.68 1150.60,272.00
             1154.66,282.03 1159.14,289.84 1171.00,290.00
             1171.00,290.00 1185.00,290.00 1185.00,290.00
             1185.00,290.00 1185.00,328.00 1185.00,328.00
             1171.80,328.00 1158.19,329.31 1146.00,323.19 Z
           M 1273.97,228.20
           C 1289.31,217.09 1288.22,180.91 1273.97,169.28
             1263.72,160.88 1246.22,168.87 1246.00,187.00
             1246.00,187.00 1246.00,232.00 1246.00,232.00
             1254.38,232.00 1267.01,233.23 1273.97,228.20 Z
           M 790.00,290.00
           C 793.99,289.99 797.41,290.22 800.96,287.99
             805.05,285.43 807.74,280.30 809.69,276.00
             814.35,265.74 816.98,252.25 817.00,241.00
             817.03,223.22 817.58,206.13 811.66,189.00
             809.33,182.26 806.52,174.84 800.00,171.09
             794.58,167.97 781.56,169.00 775.00,169.00
             775.00,169.00 775.00,290.00 775.00,290.00
             775.00,290.00 790.00,290.00 790.00,290.00 Z
           M 1831.00,170.00
           C 1826.60,170.01 1822.98,169.82 1819.04,172.23
             1813.95,175.34 1810.28,182.51 1808.34,188.00
             1804.16,199.89 1802.02,212.39 1802.00,225.00
             1801.98,240.40 1803.81,260.11 1810.76,274.00
             1813.55,279.58 1817.22,285.65 1823.00,288.55
             1827.54,290.82 1839.50,290.00 1845.00,290.00
             1845.00,290.00 1845.00,170.00 1845.00,170.00
             1845.00,170.00 1831.00,170.00 1831.00,170.00 Z
           M 1020.09,227.34
           C 1015.39,230.40 1012.02,235.85 1010.06,241.00
             1004.86,254.72 1005.25,279.40 1017.04,289.78
             1027.56,299.04 1044.77,291.94 1045.00,273.00
             1045.00,273.00 1045.00,225.00 1045.00,225.00
             1038.28,225.00 1025.57,223.78 1020.09,227.34 Z
           M 1533.09,227.85
           C 1529.11,230.69 1525.70,236.49 1523.93,241.00
             1518.60,254.56 1519.34,279.57 1531.04,289.78
             1541.65,299.04 1558.76,292.05 1559.00,272.00
             1559.00,272.00 1559.00,225.00 1559.00,225.00
             1551.72,225.00 1538.99,223.63 1533.09,227.85 Z
           M 226.00,273.94
           C 226.00,273.94 244.00,266.00 244.00,266.00
             244.00,266.00 251.28,319.00 251.28,319.00
             251.28,319.00 267.27,438.00 267.27,438.00
             267.27,438.00 273.58,485.00 273.58,485.00
             274.34,490.38 276.81,502.40 275.00,507.00
             275.00,507.00 251.01,448.00 251.01,448.00
             251.01,448.00 204.99,336.00 204.99,336.00
             204.99,336.00 183.00,282.00 183.00,282.00
             197.61,282.00 212.34,279.12 226.00,273.94 Z
           M 353.00,268.00
           C 363.68,268.02 387.76,273.11 399.00,275.58
             399.00,275.58 450.00,288.67 450.00,288.67
             459.14,291.71 468.40,294.85 477.00,299.26
             482.40,302.03 489.46,306.32 493.99,310.30
             496.70,312.68 498.64,314.92 500.53,318.00
             515.88,342.91 485.87,370.13 470.00,386.00
             470.00,386.00 448.00,407.17 448.00,407.17
             448.00,407.17 429.00,426.00 429.00,426.00
             394.93,460.07 358.49,504.35 381.31,555.00
             391.93,578.57 410.40,596.94 430.00,613.25
             465.67,642.92 524.05,672.95 567.00,691.58
             567.00,691.58 617.00,712.40 617.00,712.40
             623.31,714.92 636.39,718.94 641.00,723.00
             641.00,723.00 203.00,723.00 203.00,723.00
             192.82,722.98 190.89,720.69 182.00,716.25
             182.00,716.25 156.00,702.42 156.00,702.42
             125.69,685.08 92.36,663.70 70.66,636.00
             60.86,623.49 51.19,606.30 51.00,590.00
             51.00,590.00 51.00,580.00 51.00,580.00
             51.03,561.82 59.83,546.04 70.65,532.00
             90.54,506.20 124.82,482.94 153.00,466.58
             153.00,466.58 185.00,448.75 185.00,448.75
             185.00,448.75 218.00,432.24 218.00,432.24
             223.99,429.30 230.47,425.23 237.00,424.00
             237.00,424.00 268.72,501.00 268.72,501.00
             268.72,501.00 279.64,525.41 279.64,525.41
             279.64,525.41 283.00,527.00 283.00,527.00
             283.00,527.00 278.42,491.00 278.42,491.00
             278.42,491.00 271.72,440.00 271.72,440.00
             271.72,440.00 268.00,408.00 268.00,408.00
             268.00,408.00 312.00,388.31 312.00,388.31
             339.13,375.88 366.39,363.40 392.00,348.00
             401.47,342.31 409.17,336.89 417.00,329.00
             421.00,324.96 425.51,319.88 426.38,314.00
             428.00,303.06 413.08,294.79 405.00,290.75
             389.74,283.12 369.71,278.12 353.00,274.42
             353.00,274.42 325.00,268.00 325.00,268.00
             325.00,268.00 353.00,268.00 353.00,268.00 Z
           M 1185.00,424.00
           C 1185.00,424.00 1185.00,658.00 1185.00,658.00
             1185.01,661.15 1184.85,663.99 1185.99,667.00
             1192.60,684.37 1211.08,680.79 1224.00,674.00
             1224.00,674.00 1224.00,707.00 1224.00,707.00
             1224.00,709.03 1224.26,712.64 1223.01,714.30
             1220.77,717.27 1212.51,717.95 1209.00,718.00
             1199.48,718.11 1192.03,718.52 1183.00,714.66
             1158.27,704.10 1147.04,683.05 1147.00,657.00
             1147.00,657.00 1147.00,424.00 1147.00,424.00
             1147.00,424.00 1185.00,424.00 1185.00,424.00 Z
           M 780.00,453.00
           C 780.00,453.00 780.00,519.00 780.00,519.00
             780.00,519.00 810.00,519.00 810.00,519.00
             810.00,519.00 810.00,557.00 810.00,557.00
             810.00,557.00 780.00,557.00 780.00,557.00
             780.00,557.00 780.00,657.00 780.00,657.00
             780.01,660.41 779.88,663.76 781.15,667.00
             786.03,679.49 801.47,682.78 813.00,678.44
             815.87,677.36 818.40,675.58 821.00,674.00
             821.00,674.00 821.00,706.00 821.00,706.00
             820.99,708.63 821.35,712.26 819.40,714.30
             817.27,716.54 812.90,716.85 810.00,717.27
             801.39,718.51 792.41,718.40 784.00,715.96
             760.34,709.10 743.04,689.07 743.00,664.00
             743.00,664.00 743.00,453.00 743.00,453.00
             743.00,453.00 780.00,453.00 780.00,453.00 Z
           M 838.00,573.00
           C 838.04,548.43 852.32,527.50 876.00,519.75
             884.02,517.12 891.69,516.91 900.00,517.00
             904.07,517.05 911.54,517.63 913.98,521.39
             915.22,523.31 915.00,526.75 915.00,529.00
             915.00,529.00 915.00,561.00 915.00,561.00
             904.34,557.10 895.18,551.21 884.01,558.85
             880.79,561.06 878.11,564.27 876.85,568.00
             875.88,570.88 876.00,574.00 876.00,577.00
             876.00,577.00 876.00,715.00 876.00,715.00
             876.00,715.00 838.00,715.00 838.00,715.00
             838.00,715.00 838.00,573.00 838.00,573.00 Z
           M 959.00,528.00
           C 959.00,525.92 958.75,522.37 959.99,520.65
             962.27,517.51 969.43,517.05 973.00,517.00
             982.04,516.90 989.24,516.47 998.00,519.36
             1021.54,527.11 1035.96,547.36 1036.00,572.00
             1036.00,572.00 1036.00,662.00 1036.00,662.00
             1035.83,676.50 1030.09,689.68 1019.99,700.00
             998.68,721.76 967.99,724.69 944.01,705.33
             927.93,692.34 921.77,665.84 922.00,646.00
             922.42,610.48 942.53,578.18 981.00,578.00
             981.00,578.00 998.00,578.00 998.00,578.00
             998.00,574.26 998.13,570.64 997.06,567.00
             993.48,554.87 981.02,551.90 970.00,554.93
             966.03,556.02 962.77,558.43 959.00,560.00
             959.00,560.00 959.00,528.00 959.00,528.00 Z
           M 1286.00,678.35
           C 1301.56,689.13 1319.12,669.51 1312.44,652.00
             1308.60,641.94 1296.05,636.28 1287.00,631.75
             1265.99,621.25 1238.33,609.52 1238.00,582.00
             1237.81,565.86 1239.06,552.29 1249.52,539.00
             1273.07,509.05 1319.90,509.23 1341.78,541.00
             1350.84,554.15 1351.00,568.74 1351.00,584.00
             1351.00,584.00 1314.00,584.00 1314.00,584.00
             1314.00,575.26 1315.25,564.77 1307.90,558.39
             1295.83,547.91 1276.42,555.61 1276.01,572.00
             1275.93,575.32 1275.91,578.89 1277.23,582.00
             1280.80,590.43 1295.05,597.27 1303.00,601.25
             1323.93,611.71 1350.67,623.67 1351.00,651.00
             1351.20,668.53 1347.77,686.42 1335.82,700.00
             1310.90,728.30 1267.87,721.98 1247.22,692.00
             1237.53,677.93 1238.00,663.21 1238.00,647.00
             1238.00,647.00 1276.00,647.00 1276.00,647.00
             1276.00,660.12 1273.55,669.73 1286.00,678.35 Z
           M 1655.00,558.00
           C 1668.36,591.51 1667.89,640.58 1654.40,674.00
             1644.37,698.84 1630.08,718.33 1601.00,718.00
             1573.63,717.69 1559.79,695.75 1550.60,673.00
             1537.61,640.81 1536.57,590.25 1549.86,558.00
             1558.53,536.97 1570.48,521.29 1594.00,517.43
             1624.45,513.67 1644.12,530.72 1655.00,558.00 Z
           M 1688.00,576.00
           C 1688.02,561.89 1691.67,548.23 1700.52,537.00
             1715.87,517.50 1743.65,511.71 1766.00,521.90
             1771.95,524.61 1777.21,528.61 1782.00,533.00
             1786.11,527.54 1791.83,524.11 1798.00,521.31
             1834.01,504.96 1874.94,534.91 1875.00,574.00
             1875.00,574.00 1875.00,715.00 1875.00,715.00
             1875.00,715.00 1837.00,715.00 1837.00,715.00
             1837.00,715.00 1837.00,575.00 1837.00,575.00
             1836.99,571.25 1837.17,568.56 1835.64,565.00
             1830.40,552.89 1816.58,549.64 1807.10,559.10
             1801.65,564.55 1801.01,568.75 1801.00,576.00
             1801.00,576.00 1801.00,715.00 1801.00,715.00
             1801.00,715.00 1763.00,715.00 1763.00,715.00
             1763.00,715.00 1763.00,577.00 1763.00,577.00
             1763.00,574.35 1763.11,571.57 1762.36,569.00
             1758.23,554.68 1742.92,549.13 1732.04,560.04
             1730.24,561.85 1728.67,563.68 1727.57,566.00
             1725.86,569.58 1726.01,573.15 1726.00,577.00
             1726.00,577.00 1726.00,715.00 1726.00,715.00
             1726.00,715.00 1688.00,715.00 1688.00,715.00
             1688.00,715.00 1688.00,576.00 1688.00,576.00 Z
           M 1111.00,519.00
           C 1111.00,519.00 1111.00,715.00 1111.00,715.00
             1111.00,715.00 1073.00,715.00 1073.00,715.00
             1073.00,715.00 1073.00,557.00 1073.00,557.00
             1073.00,557.00 1054.00,557.00 1054.00,557.00
             1054.00,557.00 1054.00,519.00 1054.00,519.00
             1054.00,519.00 1111.00,519.00 1111.00,519.00 Z
           M 1506.00,715.00
           C 1469.12,714.94 1453.95,673.44 1448.92,643.00
             1447.88,636.73 1447.01,630.36 1447.00,624.00
             1447.00,624.00 1447.00,607.00 1447.00,607.00
             1447.04,578.19 1459.17,535.05 1488.00,522.87
             1499.31,518.10 1513.89,519.00 1526.00,519.00
             1526.00,519.00 1526.00,557.00 1526.00,557.00
             1519.56,557.00 1507.37,556.00 1502.00,559.09
             1496.55,562.22 1492.76,569.31 1490.45,575.00
             1484.85,588.82 1483.83,605.21 1484.00,620.00
             1484.00,620.00 1484.91,630.00 1484.91,630.00
             1485.73,641.76 1487.61,653.31 1492.97,664.00
             1495.11,668.27 1498.64,673.63 1503.00,675.83
             1505.76,677.21 1509.00,677.00 1512.00,677.00
             1512.00,677.00 1526.00,677.00 1526.00,677.00
             1526.00,677.00 1526.00,715.00 1526.00,715.00
             1526.00,715.00 1506.00,715.00 1506.00,715.00 Z
           M 1582.01,579.00
           C 1576.72,600.54 1576.51,630.45 1582.01,652.00
             1584.53,662.56 1591.31,683.56 1606.00,679.43
             1615.12,676.86 1619.81,663.24 1622.14,655.00
             1628.04,634.18 1629.45,598.85 1623.57,578.00
             1619.91,565.02 1615.06,551.22 1599.00,553.39
             1587.99,556.94 1584.66,568.89 1582.01,579.00 Z
           M 982.00,613.00
           C 971.26,613.06 966.17,619.24 962.70,629.00
             957.87,642.56 958.43,667.50 970.17,677.47
             979.00,684.96 997.74,681.64 998.00,660.00
             998.00,660.00 998.00,613.00 998.00,613.00
             998.00,613.00 982.00,613.00 982.00,613.00 Z
           M 1415.96,678.39
           C 1432.82,692.13 1422.37,721.19 1400.00,719.48
             1374.85,717.56 1370.89,682.63 1394.00,674.56
             1401.35,673.27 1409.92,673.47 1415.96,678.39 Z" />
            </svg>
        );
    }

}

StampSvg.defaultProps = {
    width : 100,
    height: 40
};

export default StampSvg;



// WEBPACK FOOTER //
// ./src/components/App/StampSvg.js